import { render, staticRenderFns } from "./Classificacao.vue?vue&type=template&id=f495f782"
import script from "./Classificacao.vue?vue&type=script&lang=ts"
export * from "./Classificacao.vue?vue&type=script&lang=ts"
import style0 from "./Classificacao.vue?vue&type=style&index=0&id=f495f782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports